import { render, staticRenderFns } from "./TeamReferralTab.vue?vue&type=template&id=68fadd26"
import script from "./TeamReferralTab.vue?vue&type=script&lang=js"
export * from "./TeamReferralTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports